import React from "react"
import styled, { css } from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const BannerContainer = styled.div`
  max-width: 1440px;
  background-color: ${props => props.backgroundColor || "transparent"};
  margin: 0 auto;
  height: 512px;
  overflow: hidden;
  ${below.tablet`
  height: 312px;
  `}
  ${below.mobile`
    height: 96px;
  `}
`

const ContactBanner = props => {
  return (
    <BannerContainer>
      <GatsbyImage
        image={props.image}
        style={{ height: "100%" }}
        objectFit="cover"
        objectPosition="50% 50%"
        alt=""
      />
    </BannerContainer>
  )
}

export default ContactBanner
